// Generated by Melange


const $$default = {
  routes: /* [] */ 0,
  label: ""
};

export {
  $$default as default,
}
/* No side effect */
